<mat-card class="details">
  @if (user && !user.isProfileCompleted && !isInternalUser()) {
    <div class="alert">
      <span class="warning-icon">&#9888;</span>
      {{ 'Incomplete_Profile_Warning_Message' | translate }}
    </div>
  }
  <!-- Header -->
  <mat-card-header>
    <div class="user-detail-header">
      <mat-tab-group
        (selectedIndexChange)="onChangeTab($event)"
        class="tab-width"
        animationDuration="0ms"
      >
        @for (tab of tabs; track tab) {
          <mat-tab [label]="tab.name"> </mat-tab>
        }
      </mat-tab-group>
    </div>  
  </mat-card-header>
  <!-- Content -->
  <mat-card-content class="max-height">
    @if (disableSave) {
      <div class="warning">
        <mat-icon> warning_amber </mat-icon>&nbsp;{{ 'self_warning' | translate }}
      </div>
    }
    <app-user-application-access
      [saveChanges]="updateRecords"
      [ngClass]="selectedTab?.id === 1 ? 'hide' : ''"
      [user]="user"
      [clientId]="clientId"
      (isChanged)="isChanged($event)"
      (isValid)="isAppsValid($event)"
    >
    </app-user-application-access>
    @if (selectedTab?.id === 1) {
      <app-user-activity
        [ngClass]="selectedTab?.id === 0 ? 'hide' : ''"
        [activityLogs]="logs"
        [userName]="user.name"
      >
      </app-user-activity>
    }
  </mat-card-content>
  <!-- Footer -->
  <mat-card-actions>
    <button mat-stroked-button color="primary" (click)="close()">
      {{ 'USER_DETAILS.close' | translate }}
    </button>
    <button
      color="primary"
      mat-flat-button
      (click)="saveData()"
      [disabled]="disableSave || !appChanges || !appsValid"
    >
      {{ 'USER_DETAILS.save' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
